var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "chart-title" }, [
        _vm._v(
          "Overview statistics describing the areas of interest and coverage of different MPA types."
        ),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "area-overview" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "mpa-overview" } }),
      _vm._v(" "),
      _c("p", { staticStyle: { "font-size": "80%" } }, [
        _vm._v(
          'Note: summing the area of the individual MPA types will result in a figure greater than the "In MPA" value - this is because some MPA types overlap with others. The "In MPA" value doesn\'t include any double counting.'
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticStyle: { "font-size": "80%" } }, [
        _vm._v(
          "Note: the area covered by Highly Protected Marine Areas (HPMAs) is very small compared to the other MPA types. You can zoom the chart to better see the differences."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }